import { SubSink } from 'subsink';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { PageState } from '../page-state.enum';
import { AuthService, AuthUser } from '@monorepo/ui/auth';

@Component({
  selector: 'monorepo-admin-chat-panel',
  templateUrl: './admin-chat-panel.component.html',
  styleUrls: ['./admin-chat-panel.component.scss'],
})
export class AdminChatPanelComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  pageState: PageState = PageState.LOADING;
  pageStateEnum: any = PageState;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.subs.sink = this.authService.user.subscribe({
      next: (user: AuthUser): void => {
        if (user) {
          this.pageState = this.pageStateEnum.LOADED;
        }
      },
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
